import { render, staticRenderFns } from "./PackageCard.vue?vue&type=template&id=c923c952&scoped=true"
import script from "./PackageCard.vue?vue&type=script&lang=ts"
export * from "./PackageCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c923c952",
  null
  
)

export default component.exports